module.exports = __webpack_public_path__ + "static/download-btn-googleplay-930ba69072baf226219ac277ad24aade.png";